import { StyledBoxCard } from "./styled";
import { IBoxCardProps } from "./types";

const BoxCard = ({ children, ...props }: IBoxCardProps) => (
    <StyledBoxCard {...props}>
        {children}
    </StyledBoxCard>
)

export { BoxCard }